import {
  MFAChannel,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {redirectWithForwardUrl} from 'utils/utils';

import {useGetForwardUrl} from 'hooks/useGetFowardUrl';

import FullPageLoader from '../PanelContainer/FullPageLoader';

import PreferenceSelector from './PreferenceSelector';
import PreferenceSelectorNoInfo from './PreferenceSelectorNoInfo';

export interface PreferenceSelectorWrapperProps {
  mobilePhone: string | undefined;
  securityEmail: string | undefined;
  onSendPress: () => void;
  onSelectChannel: (channel: MFAChannel) => void;
  selectedChannel: MFAChannel | undefined;
  isVip: boolean;
  isLoading: boolean;
  marketingEmail: string | undefined;
}

const PreferenceSelectorWrapper: React.FunctionComponent<
  PreferenceSelectorWrapperProps
> = (props) => {
  const {
    mobilePhone,
    securityEmail,
    onSendPress,
    selectedChannel,
    onSelectChannel,
    isVip,
    isLoading,
    marketingEmail,
  } = props;

  const forwardUrl = useGetForwardUrl();
  const optinStatus = useWidgetState(Selectors.mfaOptinStatusSelector) as
    | boolean
    | undefined;

  // user is already opted in, we can send them back to the forwardUrl
  if (optinStatus) {
    redirectWithForwardUrl(forwardUrl);
    return null;
  }

  const hasNoContact = !(mobilePhone || securityEmail || marketingEmail);

  if (isLoading) {
    return <FullPageLoader />;
  } else {
    if (hasNoContact) {
      return <PreferenceSelectorNoInfo isLoading={isLoading} />;
    } else {
      return (
        <PreferenceSelector
          mobilePhone={mobilePhone}
          securityEmail={securityEmail}
          onSendPress={onSendPress}
          selectedChannel={selectedChannel}
          onSelectChannel={onSelectChannel}
          isVip={isVip}
          isLoading={isLoading}
          marketingEmail={marketingEmail}
        />
      );
    }
  }
};

export default PreferenceSelectorWrapper;
